import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from "redux";
import SimpleReactValidator from 'simple-react-validator';
import { createVehicleType, getVehicleTypeDetails, editVehicleType } from "../../redux/actions/master"

class VehicleTypeClass extends Component {

	state = {
		vehicleTypeDetails: {
            title: '',

		},
		isEdit: false,
	}

	componentWillMount() {
		this.validator = new SimpleReactValidator({
			element: message => <span className="error-message ">{message}</span>,
			autoForceUpdate: this,
			messages: {}
		});
	}

	componentWillReceiveProps(props) {

		let { modalDetails, isEdit } = props

		this.setState({
			vehicleTypeDetails: modalDetails,
			isEdit: isEdit,
		})
	}

	handleInputs = ({ target: { value, name } }) => {

		let vehicleTypeDetails = Object.assign({}, this.state.vehicleTypeDetails)

		vehicleTypeDetails[name] = value

		this.setState({
			vehicleTypeDetails
		})


	}

	handleSubmit = () => {

		if (this.validator.allValid()) {

			let { vehicleTypeDetails: { title, id = '' }, isEdit } = this.state

			let body = {
                title: title,
                status:1
			}

			if (!isEdit) {

				this.props.createVehicleType(body).then(() => {

					this.props.getVehicleTypeDetails().then(() => {
						let temp = {
                            title: '',
						}

						this.setState({
							isEdit: false,
							pickupDropDetails: temp

						})
					})
				})
			} else {

				this.props.editVehicleType(id, body).then((message) => {

					this.props.getVehicleTypeDetails().then(() => {
						let temp = {
                            title: '',
						}

						this.setState({
							isEdit: false,
							vehicleTypeDetails: temp

						})
					})

				})
			}
			this.props.toggle()

			this.validator.hideMessages();

		} else {
			this.setState({
				isError: true
			})
			this.validator.showMessages();

		}
	}
	render() {

		let { isError, isEdit, toggle } = this.props

		let { vehicleTypeDetails } = this.state

		this.validator.purgeFields();

		let { title } = vehicleTypeDetails

		return (
			<section className="side-slider h-100">
				<div className="slider-header p-4">
					<div className="d-flex align-items-center">
						<h5 className="sair-sec-title"> {isEdit ? "Edit Pickup/Drop Location" : "Add Pickup/Drop Location"}</h5>
						<div className="ml-auto">
							<i className="icon-close font-md px-2 cursor-pointer"
								onClick={toggle}
							></i>
						</div>
					</div>
				</div>
				<div className="slider-body p-4">
					<div className={`row no-gutters ${isError ? "was-validated" : ""}`}>
						<div className="col-md-12 form-group">
							<label>Vehicle Type</label>
							<input
								className={`form-control ${this.validator.message('title', title, 'required') ? 'inValid' : ''}`} id="title"
								placeholder=""
								name="title"
								value={title}
								type="text"
								onChange={this.handleInputs}


							/>
							{this.validator.message('title', title, 'required')}
						</div>

					</div>

					<hr />
					<button
						className="btn btn-primary"

						onClick={() => this.handleSubmit()}

					>{isEdit ? "Update" : "Submit"}</button>
				</div>
			</section>
		)
	}
}

const mapStateToProps = state => {

	return {}

};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({
		createVehicleType,
		getVehicleTypeDetails,
		editVehicleType
	}, dispatch)
};



export const VehicleTypeModal = connect(mapStateToProps, mapDispatchToProps)(VehicleTypeClass)
